let validateDate = dateString => {
  //input: dd.MM.YYYY (double-digits day and month)
  if (typeof dateString !== "string") return false;
  if (dateString.split(".").length !== 3) return false;
  let day = dateString.split(".")[0];
  let month = dateString.split(".")[1];
  let year = dateString.split(".")[2];
  return (
    !(isNaN(day) || isNaN(month) || isNaN(year)) &&
    day > 0 &&
    day < 32 &&
    month > 0 &&
    month < 13 &&
    year > 0 &&
    year < 9999
  );
};

export default validateDate;
